import { useEffect } from "react";
import { useRawTable } from "../../hooks";

export default function Module_ElderlyHealth_AD8TotalScoreToCheckYear({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const { setTbData, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle1",
  });

  useEffect(() => {
    if (!apiData) return;

    const formatData = sumByAD8({ data: apiData });

    setTbData({
      raw: [
        ...apiData,
        { ...formatData.ad8_0_1, AD8: "0~1小計", isSkip: true, isFoot: true },
        { ...formatData.ad8_2_8, AD8: "2~8小計", isSkip: true, isFoot: true },
      ],
      format: null,
      export: null,
    });
  }, [apiData]);

  const sumByAD8 = ({ data }) => {
    // 需要加總的年度欄位
    const years = moduleData.levelColumns.options.map((item) => item.label);

    // 初始化
    const result = {
      ad8_0_1: {},
      ad8_2_8: {},
    };
    years.forEach((y) => {
      result.ad8_0_1[y] = 0;
      result.ad8_2_8[y] = 0;
    });

    // 分組加總
    data.forEach((item) => {
      years.forEach((y) => {
        if (item[y] !== undefined) {
          if (item.AD8 === 0 || item.AD8 === 1) {
            result.ad8_0_1[y] += item[y];
          } else if (item.AD8 >= 2 && item.AD8 <= 8) {
            result.ad8_2_8[y] += item[y];
          }
        }
      });
    });

    return result;
  };

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
